export default __webpack_public_path__ + "static/media/hessahStore5.43daf6ce.jpg";